<template>
  <div>
    <v-col
      cols="12"
      class="body-bold-smaller py-0"
    >
      <a type="primary" size="xsmall" @click="handleBack">
        <v-icon size="12" class="backIcon">mdi-arrow-left</v-icon>
        {{ $t('message.actions.return') }}
      </a>
    </v-col>
    <v-col cols="12" class="pb-2 pt-1 mb-8">
      <span class="text-h6 mr-2" style="vertical-align: middle">
        PandaAssist AI
      </span>
      <span
        class="body-regular-smaller neutral-40-light-text"
        style="display: flex; gap: 2px; align-items: center"
      >
        {{ $t('message.pages.pandaAssist.videoIntern.subtitle') }}
        <a
          type="secondary"
          class="d-flex align-center body-bold-smaller mb-0"
          :href="embedArticle"
          target="_blank"
        >
          <span class="neutral-30-base-text">
            {{ $t('message.knowMore') }}</span
          >
          <v-icon size="16">mdi-open-in-new</v-icon>
        </a>
      </span>
    </v-col>
    <!-- <v-container :class="{ 'd-none': !isLoading }">
      <v-row class="d-flex">
        <v-col cols="12">
          <v-skeleton-loader
            class="border loader-width pr-5 skeleton-slider"
            type="image"
          ></v-skeleton-loader>
        </v-col>
        <v-col cols="12">
          <div class="skeleton-btn-loader-container">
            <v-skeleton-loader
              class="border pr-5 skeleton-button"
              type="button"
            ></v-skeleton-loader>
          </div>
        </v-col>
      </v-row>
    </v-container> -->
    <v-card
      v-if="!selectedPandaAssist && !isLoading"
      flat
      style="display: grid; justify-items: center"
    >
      <EmptyAssistAi />
      <base-btn @click="openModal" class="mt-10" size="small">
        {{
          $t(
            'message.pages.pandaAssist.selectPandaAssist.emptyState.buttonText'
          )
        }}
      </base-btn>
      <SelectPandaAssist
        :openSelectPanda="openSelectPanda"
        @openModalChangeAssist="openCreatePanda"
        @update:openSelectPanda="openSelectPanda = $event"
        @buyConfirm="getPandaAssists"
      />
    </v-card>
    <v-card
      v-if="selectedPandaAssist"
      flat
      style="
        display: grid;
        justify-items: center;
        align-content: space-between;
        height: 600px;
      "
    >
      <v-col
        cols="12"
        class="pa-0"
        style="display: grid; justify-items: center"
      >
        <ChangePandaAssist
          :dialog-change-visible="dialogChangeVisible"
          @update:dialog-change-visible="dialogChangeVisible = $event"
        />

        <BaseActionList
          :title="$t('message.pages.pandaAssist.videoIntern.activeAi')"
          :subtitle="$t('message.pages.pandaAssist.videoIntern.showAi')"
        >
          <template #secondary-action>
            <v-switch v-model="activePandaAssist" class="mt-0" hide-details />
          </template>
        </BaseActionList>

        <v-col cols="12" class="py-2">
          <v-divider class="mb-8 my-4"></v-divider>

          <div style="display: grid; mb-2">
            <h3 class="body-regular-base">
              {{ $t('message.pages.pandaAssist.videoIntern.videoKnowledgeAI') }}
            </h3>
            <span class="body-regular-smaller" style="color: #636578">
              {{
                $t('message.pages.pandaAssist.videoIntern.chatAnswers')
              }}</span
            >
          </div>

          <BaseActionList :title="selectedPandaAssist.name">
            <template #custom-icon>
              <simple-svg
                width="16px"
                height="16px"
                fill="neutral-60"
                :src="require('@/assets/chat_icon_gray.svg')"
              />
            </template>
            <template #secondary-action>
              <base-btn
                type="tertiary"
                size="small"
                @click="redirectToPandaAssist"
                >{{ $t('message.embedModal.domainBtn') }}
                <v-icon size="20" color="#3F404C"
                  >mdi-open-in-new</v-icon
                ></base-btn
              >
            </template>
          </BaseActionList>
        </v-col>
      </v-col>
      <v-col cols="12">
        <v-divider class="pa-3"></v-divider>
        <div class="d-flex flex-row actions-row">
          <v-spacer></v-spacer>
          <v-tooltip max-width="184px" :disabled="wasChangedSomething" top>
            <template v-slot:activator="{ on, attrs }">
              <div class="pl-2" v-bind="attrs" v-on="on">
                <base-btn
                  :disabled="!wasChangedSomething"
                  type="tertiary"
                  @click="
                    wasChangedSomething = false
                    activePandaAssist = chat_is_visible
                  "
                >
                  {{ $t('message.actions.cancel') }}
                </base-btn>
              </div>
            </template>
            <span>{{ $t('message.noChanges') }}</span>
          </v-tooltip>
          <v-tooltip max-width="184px" :disabled="wasChangedSomething" top>
            <template v-slot:activator="{ on, attrs }">
              <div class="pl-2 mr-8" v-bind="attrs" v-on="on">
                <base-btn
                  :disabled="!wasChangedSomething"
                  @click="updateChatVisibility"
                >
                  {{ $t('message.actions.publish') }}
                </base-btn>
              </div>
            </template>
            <span>{{ $t('message.noChanges') }}</span>
          </v-tooltip>
        </div>
      </v-col>
    </v-card>
    <template v-if="isLoading">
      <v-container>
        <v-row class="d-flex mt-2">
          <v-col cols="12">
            <v-skeleton-loader
              class="border loader-width"
              type="chip"
            ></v-skeleton-loader>
          </v-col>
          <v-col cols="12">
            <v-skeleton-loader
              class="border loader-width"
              type="image"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <CreatePandaAssist
      :dialog-visible="dialogVisible"
      :video_external="this.video"
      @update:dialog-visible="dialogVisible = $event"
      @buyConfirm="getPandaAssists"
    />
  </div>
</template>
<script>
import SelectPandaAssist from './SelectPandaAssist.vue'
import EmptyAssistAi from './EmptyAssistAi.vue'
import BaseBtn from '../../../../components/BaseBtn.vue'
import ChangePandaAssist from './ChangePandaAssist.vue'
import CreatePandaAssist from '../../../PandaAssist/CreatePandaAssist.vue'
import BaseActionList from '@/components/BaseActionList'
import pandaAssist from '@/services/pandaAssist'
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  name: 'PandaAssistPage',
  components: {
    SelectPandaAssist,
    EmptyAssistAi,
    BaseBtn,
    ChangePandaAssist,
    CreatePandaAssist,
    BaseActionList,
  },
  props: {
    handleBack: {
      type: Function,
      required: true,
    },
    hasEdit: {
      type: Array,
    },
  },
  data() {
    return {
      activePandaAssist: false,
      openSelectPanda: false,
      loadingSlider: false,
      isLoading: false,
      dialogVisible: false,
      dialogChangeVisible: false,
      selectedPandaAssist: false,
      wasChangedSomething: false,
      chat_is_visible: false,
      chatAssistantId: '',
      articles: {
        pt: 'https://help.pandavideo.com/pt-br/article/pandaassist-ai-como-criar-chats-com-ia-nos-seus-videos-zdy32s/',
        en: 'https://help.pandavideo.com/en-us/article/pandaassist-ai-how-to-create-ai-chats-in-your-videos-r4624o/',
        es: 'https://help.pandavideo.com/es/article/pandaassist-ai-como-crear-chats-con-ia-en-tus-videos-1ewhd32/',
      },
      columns: [
        { title: 'Name', key: 'name' },
        { title: 'Status', key: 'status' },
      ],
      data: [],
      options: {
        rowKey: 'id',
      },
    }
  },
  computed: {
    ...mapState({
      video: (state) => state.video.video,
      profile: (state) => state.video.profile,
      hasStatus: (state) => state.video.aiWorkFlow?.status,
      hasData: (state) => state.video.aiWorkFlow?.data,
      isEnabled: (state) => state.video.aiWorkFlow?.isEnabled,
    }),

    embedArticle() {
      const lang = this.$i18next.language || this.$i18n?.locale || 'en'
      switch (lang) {
        case 'pt-BR':
        case 'pt':
          return this.articles.pt
        case 'es':
          return this.articles.es
        case 'en':
        default:
          return this.articles.en
      }
    },
  },
  watch: {
    activePandaAssist(newValue) {
      this.wasChangedSomething = this.chat_is_visible !== newValue
    },
    buyConfirm(newValue) {
      if (newValue) this.getPandaAssists()
    },
  },
  methods: {
    ...mapMutations('user', [
      'UPDATE_GLOBAL_SNACKBAR',
      'UPDATE_GLOBAL_BASE_MODAL_MESSAGE',
    ]),
    ...mapActions('video', [
      'updateProfile',

      'createProfile',

      'setProfileToVideos',
    ]),
    ...mapMutations('video', ['UPDATE_VIDEO', 'UPDATE_STATUS_ERROR']),
    openModalChangeAssist() {
      this.dialogChangeVisible = true
    },
    openModal() {
      this.openSelectPanda = true
    },
    openCreatePanda(value) {
      this.dialogVisible = value
    },
    redirectToPandaAssist() {
      this.$router.push('/panda-assist')
    },
    async getAssist() {
      const response = await pandaAssist.getAssistantById(
        this.video.config.assistant_id
      )
      this.selectedPandaAssist = response.data
    },
    changeVisibility(value) {
      this.activePandaAssist = value
      this.wasChangedSomething = this.chat_is_visible !== this.activePandaAssist
    },
    async updateChatVisibility() {
      await pandaAssist.updateChatVisibility({
        assistant_id: this.selectedPandaAssist.id,
        video_id: this.video.id,
        chat_is_visible: this.activePandaAssist,
      })
      this.wasChangedSomething = false
      this.chat_is_visible = this.activePandaAssist

      this.$root.$emit('updateEmbedPreviewChange')
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        type: 'success',
        text: this.$t('message.toggleVisibility'),
      })
    },
    async getPandaAssists() {
      this.isLoading = true
      const response = await pandaAssist.getAssistants()

      this.pandaAssists = response.data?.filter(
        (item) => item.status !== 'deleted' && item.status !== 'failed'
      )
      this.noCredits = this.pandaAssists?.some(
        (item) => item.status === 'payment_failed'
      )

      this.selectedPandaAssist = response.data?.find((item) =>
        item.videos.some((video) => video.id === this.video.id)
      )
      if (!this.selectedPandaAssist) return (this.isLoading = false)
      const video = this.selectedPandaAssist?.videos?.find(
        (video) => (video.id = this.video.id)
      )
      this.activePandaAssist = video.chat_is_visible
      this.chat_is_visible = video.chat_is_visible
      this.isLoading = false
    },
  },
  created() {
    this.getPandaAssists()
  },
  mounted() {
    // this.getAssist()
    this.getPandaAssists()
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/src/data-tableV2';
.rowIsSelected {
  background-color: #e0f7fa;
}
.backIcon {
  color: varFigma(brand-60-base) !important;
}
.neutral-40-light-text {
  color: varFigma(neutral-40-light);
}
.neutral-30-base-text {
  color: varFigma(neutral-30-base) !important;
}
.rowIsDragged {
  opacity: 0.5;
}
.editButton {
  font-size: 12px !important;
  height: 24px !important;
  padding: 0 20px !important;
  border-radius: 4px !important;
}
::v-deep .panda-search:before {
  content: '\e90f';
  font-size: 16px;
}
::v-deep .item-line {
  border-top: 1px solid varFigma(neutral-95-lightest) !important;
}
</style>
<style lang="scss">
.t-header {
  display: none;
}
</style>
